import store from '@/store'
import router from '@/router'
import Vue from 'vue'
Vue.directive('role-permission', {
	bind(el, binding, vnode) {
		// 获取绑定的权限值
		const permission = binding.value;
		const role = store.getters.role;
		// 检查用户是否拥有权限
		if (Array.isArray(permission)) {
			if (!permission.includes(role)) {
				Vue.nextTick(() => {
					el.parentNode && el.parentNode.removeChild(el);
				})
			}
		} else {
			if (role !== permission) {
				Vue.nextTick(() => {
					el.parentNode && el.parentNode.removeChild(el);
				})
			}
		}
	}
});
Vue.directive('permission', {
	bind(el, binding, vnode) {
		// 获取绑定的权限值
		const permission = binding.value;
		const addRoutes = JSON.parse(JSON.stringify(store.getters.addRoutes));
		// 检查用户是否拥有权限
		let localHash = window.location.hash
		let flag = false;
		let path = ''
		let fun = (arr) => {
			arr.forEach((item, index) => {
				path += item.path + '/'
				if (item.children && item.children.length) {
					fun(item.children)
				} else {
					if (localHash.indexOf(path.slice(0, -1)) !== -1 && item.meta.children && item
						.meta.children
						.length) {
						item.meta.children.forEach((v, i) => {
							if (v.name == permission) {
								flag = true
							}
						})
					}
					path = ''
				}
			})
		}
		fun(addRoutes)
		if (!flag) {
			Vue.nextTick(() => {
				el.parentNode && el.parentNode.removeChild(el);
			})
		}
	}
});

Vue.prototype.$getPermission = (permission) => {
	const addRoutes = JSON.parse(JSON.stringify(store.getters.addRoutes));
	// 检查用户是否拥有权限
	let localHash = window.location.hash
	let flag = false;
	let path = ''
	let fun = (arr) => {
		arr.forEach((item, index) => {
			path += item.path + '/'
			if (item.children && item.children.length) {
				fun(item.children)
			} else {
				if (localHash.indexOf(path.slice(0, -1)) !== -1 && item.meta.children && item
					.meta.children
					.length) {
					item.meta.children.forEach((v, i) => {
						if (v.name == permission) {
							flag = true
						}
					})
				}
				path = ''
			}
		})
	}
	fun(addRoutes)
	return flag
}